import ComponentsArrRenderer from '../../../components/core/ComponentsArrRenderer';
import { useIsUserLoggedIn } from '../../../global-utils';
import { withIsActiveGuard } from '../../utils';
import { MODULE_NAME } from '../model/constants';
import getSettings from '../model/get-settings';
import useUserBoot from '../model/use-user-boot';
import { checkBlock, checkPassThrough  } from './tool-box';
import { stripOrigin } from '../../../shared/misc';

const UserBoot = ({ children, ...restProps }) => {
  const moduleSettings = getSettings();
  const { components } = moduleSettings;
  const { isLoading } = useUserBoot();
  const isLoggedIn = useIsUserLoggedIn();
  const currentUrl = stripOrigin(window.location.href);
  const canPassThrough = checkPassThrough(moduleSettings)({ url: currentUrl });
  const shouldBlock = checkBlock(moduleSettings)({isLoggedIn});

  // ORDER MATTERS
  if (isLoading) return <ComponentsArrRenderer {...restProps} components={components} />;
  if (canPassThrough) return children;
  if (shouldBlock) return <ComponentsArrRenderer {...restProps} components={components} />;

  return children;
};

export default withIsActiveGuard(MODULE_NAME)(UserBoot);
